import { defineMessages } from 'react-intl';

const messages = defineMessages({
    emptyMessage: { id: 'emptyMessage', defaultMessage: ' ' },

    // Roles
    roleAdminSuper: { id: 'roleAdminSuper', defaultMessage: 'Super Administrator' },
    roleAdminHumanResources: { id: 'roleAdminHumanResources', defaultMessage: 'Client Success Rep' },
    roleAdminFinance: { id: 'roleAdminFinance', defaultMessage: 'Administrator Finance' },
    roleClientAdmin: { id: 'roleClientAdmin', defaultMessage: 'Client Administrator' },
    roleClientTimesheetApprover: { id: 'roleClientTimesheetApprover', defaultMessage: 'Client Timesheet Approver' },
    roleClientHiringManager: { id: 'roleClientHiringManager', defaultMessage: 'Client Hiring Manager' },
    manager: { id: 'manager', defaultMessage: 'Manager' },
    theManager: { id: 'theManager', defaultMessage: 'Manager' },
    roleWorkerContractor: { id: 'roleWorkerContractor', defaultMessage: 'Contractor' },

    // Personal info
    name: { id: 'name', defaultMessage: 'Name' },
    yourName: { id: 'yourName', defaultMessage: 'Your Name' },
    email: { id: 'email', defaultMessage: 'Email' },
    workerEmail: { id: 'workerEmail', defaultMessage: 'Worker Email' },
    role: { id: 'role', defaultMessage: 'Role' },
    status: { id: 'status', defaultMessage: 'Status' },
    verificationCode: { id: 'verificationCode', defaultMessage: 'Verification Code' },
    password: { id: 'password', defaultMessage: 'Password' },
    newPassword: { id: 'newPassword', defaultMessage: 'New Password' },
    setYourPassword: { id: 'setYourPassword', defaultMessage: 'Set password, including uppercase, lowercase, number & symbol' },
    retypePassword: { id: 'retypePassword', defaultMessage: 'Retype password' },
    firstName: { id: 'firstName', defaultMessage: 'First Name' },
    middleName: { id: 'middleName', defaultMessage: 'Middle Name' },
    noMiddleName: { id: 'iDoNotHaveMiddleName', defaultMessage: 'I do not have a middle name' },
    lastName: { id: 'lastName', defaultMessage: 'Last Name' },
    otherLastNames: { id: 'otherLastNames', defaultMessage: 'Other Last Names Used (if any)' },
    socialSecurityNumber: { id: 'socialSecurityNumber', defaultMessage: 'Social Security #' },
    nationalInsuranceNumber: { id: 'nationalInsuranceNumber', defaultMessage: 'National Insurance Number' },
    companyRegistrationNumber: { id: 'companyRegistrationNumber', defaultMessage: 'Company Registration Number' },
    driversLicenseNumber: { id: 'driversLicenseNumber', defaultMessage: 'Drivers License Number' },
    driversLicenseState: { id: 'driversLicenseState', defaultMessage: 'Drivers License State' },
    phone: { id: 'phone', defaultMessage: 'Phone' },
    phoneNumber: { id: 'phoneNumber', defaultMessage: 'Phone number' },
    companyPhone: { id: 'companyPhone', defaultMessage: 'Company Phone' },
    dateOfBirth: { id: 'dateOfBirth', defaultMessage: 'Date of Birth' },
    date: { id: 'date', defaultMessage: 'Date' },
    dateFormat: { id: 'dateFormat', defaultMessage: 'mm/dd/yyyy' },
    gender: { id: 'gender', defaultMessage: 'Gender' },
    dueDate: { id: 'dueDate', defaultMessage: 'Due Date' },
    amount: { id: 'amount', defaultMessage: 'Amount' },
    proceed: { id: 'proceed', defaultMessage: 'Proceed With Action' },
    timeType: { id: 'timeType', defaultMessage: 'Time Type' },
    time: { id: 'time', defaultMessage: 'Time' },
    hours: { id: 'hours', defaultMessage: 'Hours' },
    delExp: { id: 'delExp', defaultMessage: 'Other' },
    minutes: { id: 'minutes', defaultMessage: 'Minutes' },
    period: { id: 'period', defaultMessage: 'Period' },
    day: { id: 'day', defaultMessage: 'Day' },
    month: { id: 'month', defaultMessage: 'Month' },
    year: { id: 'year', defaultMessage: 'Year' },
    address: { id: 'address', defaultMessage: 'Address' },
    addressSecondary: { id: 'addressSecondary', defaultMessage: 'Address 2' },
    aptNumber: { id: 'aptNumber', defaultMessage: 'Apt. Number' },
    city: { id: 'city', defaultMessage: 'City' },
    state: { id: 'state', defaultMessage: 'State' },
    stateOrProvince: { id: 'stateOrProvince', defaultMessage: 'State' },
    province: { id: 'province', defaultMessage: 'Province' },
    postCode: { id: 'postCode', defaultMessage: 'Zip' },
    country: { id: 'country', defaultMessage: 'Country' },
    addressKind: { id: 'addressKind', defaultMessage: 'Address Type' },
    addressName: { id: 'addressName', defaultMessage: 'Address Name (eg Headquarters, Home, etc.)' },
    mailingAddress: { id: 'mailingAddress', defaultMessage: 'Mailing Address' },
    postalAddress: { id: 'postalAddress', defaultMessage: 'Postal Address' },
    relationship: { id: 'relationship', defaultMessage: 'Relationship' },
    emergencyContact: { id: 'emergencyContact', defaultMessage: 'Emergency Contact' },
    emergencyPhone: { id: 'emergencyPhone', defaultMessage: 'Emergency Phone' },
    emergencyName: { id: 'emergencyName', defaultMessage: 'Emergency Contact Name' },
    emergencyEmail: { id: 'emergencyEmail', defaultMessage: 'Emergency Contact Email' },

    // Education verification
    educationVerification: { id: 'educationVerification', defaultMessage: 'Education Verification' },
    schoolDegree: { id: 'highestDegree', defaultMessage: 'Degree' },
    schoolMajor: { id: 'schoolMajor', defaultMessage: 'Major' },
    schoolName: { id: 'schoolName', defaultMessage: 'School Name' },
    schoolWebsite: { id: 'schoolWebsite', defaultMessage: 'School Web Site' },
    degreeAchievedOrExpected: { id: 'degree', defaultMessage: 'Degree', helpText: 'BA, MS, etc.' },
    degreeStatus: { id: 'degreeStatus', defaultMessage: 'Degree Status' },
    yearExpected: { id: 'yearExpected', defaultMessage: 'Year Expected' },
    yearCompleted: { id: 'yearExpected', defaultMessage: 'Year Awarded' },
    nameOnDiploma: { id: 'diplomaName', defaultMessage: 'Name On Diploma' },
    currentlyEnrolled: { id: 'currentlyEnrolled', defaultMessage: 'Currently Enrolled?' },

    // employment verification
    employmentVerification: { id: 'employmentVerification', defaultMessage: 'Employment Verification' },
    mostRecentEmployer: { id: 'mostRecentEmployer', defaultMessage: 'Most Recent Employer' },
    position: { id: 'position', defaultMessage: 'Position' },
    approxStartDate: { id: 'approxStartDate', defaultMessage: 'Start Date (approximate)' },
    approxEndDate: { id: 'approxEndDate', defaultMessage: 'End Date (approximate)' },
    managerEmail: { id: 'managerEmail', defaultMessage: 'Manager Email' },

    // Company info
    client: { id: 'client', defaultMessage: 'Client' },
    company: { id: 'company', defaultMessage: 'Company' },
    companyName: { id: 'companyName', defaultMessage: 'Company Name' },
    dba: { id: 'dbaName', defaultMessage: `DBA` },
    dbaName: { id: 'dbaName', defaultMessage: `Worker's Business or DBA Name` },
    dbaNameOptional: { id: 'dbaNameOptional', defaultMessage: `Worker's Business or DBA Name (optional)` },
    lcNameOptional: { id: 'lcNameOptional', defaultMessage: 'Limited Company name (optional)' },
    lcName: { id: 'lcName', defaultMessage: 'Limited Company name' },
    businessName: { id: 'businessName', defaultMessage: 'Business Name (or your name, if none)' },
    businessURL: { id: 'businessURL', defaultMessage: 'Business Web Site' },
    linkedIn: { id: 'linkedIn', defaultMessage: 'LinkedIn Profile' },
    companyTaxId: { id: 'companyTaxId', defaultMessage: 'Tax ID' },
    taxCode: { id: 'taxCode', defaultMessage: 'Tax Code' },
    companyVATIN: { id: 'companyVATIN', defaultMessage: 'VAT Number' },
    companyUTR: { id: 'companyUTR', defaultMessage: 'UTR' },
    typeOfBusiness: { id: 'typeOfBusiness', defaultMessage: 'Type of Business' },
    taxClassification: { id: 'taxClassification', defaultMessage: 'Select' },
    exemptPayeeCode: { id: 'exemptPayeeCode', defaultMessage: 'Exempt payee code (if any)' },
    exemptFatcaCode: { id: 'exemptFatcaCode', defaultMessage: 'Exemption from FATCA reporting code (if any)' },
    companyURL: { id: 'companyURL', defaultMessage: 'Company Home Page' },
    companyIfApplicable: { id: 'companyIfApplicable', defaultMessage: 'Company (if applicable)' },
    companyRequired: { id: 'companyRequired', defaultMessage: 'Client Name' },
    companyInfoUpdated: { id: 'companyInfoUpdated', defaultMessage: 'Company information updated.' },
    assignmentDeleted: { id: 'assignmentDeleted', defaultMessage: 'Assignment deleted.' },
    assignmentTerminated: { id: 'assignmentTerminated', defaultMessage: 'Assignment terminated.' },
    w2Rejected: { id: 'w2Rejected', defaultMessage: 'Worker reset to IC-only onboarding.' },
    exportPayroll: { id: 'exportPayroll', defaultMessage: 'Export Payroll' },
    deleteAssignment: { id: 'deleteAssignment', defaultMessage: 'Delete Assignment' },
    terminate: { id: 'terminate', defaultMessage: 'Terminate' },
    terminateAssignment: { id: 'terminateAssignment', defaultMessage: 'Terminate Assignment' },
    rejectClassification: { id: 'rejectClassification', defaultMessage: 'Reject Proposed Classification' },
    deleteAssignmentConfirmation: { id: 'deleteConfirmation', defaultMessage: 'Delete this assignment? (NOT RECOMMENDED)' },
    terminateAssignmentConfirmation: { id: 'terminateConfirmation', defaultMessage: 'Terminate this assignment?' },
    contact: { id: 'contact', defaultMessage: 'Contact' },
    config: { id: 'config', defaultMessage: 'Config' },
    contactFirstName: { id: 'contactFirstName', defaultMessage: 'Contact First Name' },
    contactLastName: { id: 'contactLastName', defaultMessage: 'Contact Last Name' },
    contactEmail: { id: 'contactEmail', defaultMessage: 'Contact Email' },
    contactPhone: { id: 'contactPhone', defaultMessage: 'Contact Phone' },
    contactPerson: { id: 'contactPerson', defaultMessage: 'Contact Person' },
    businessAddress: { id: 'businessAddress', defaultMessage: 'Business Address' },
    businessAddress2: { id: 'businessAddress2', defaultMessage: 'Business Address Line 2 (optional)' },
    perHour: { id: 'perHour', defaultMessage: '/hr' },
    hourly: { id: 'hourly', defaultMessage: 'Per hour' },
    perProject: { id: 'perProject', defaultMessage: 'Per project' },
    type: { id: 'type', defaultMessage: 'Type' },
    declaration: { id: 'declaration', defaultMessage: 'Declaration' },
    iConfirm: { id: 'iConfirm', defaultMessage: 'I confirm that the information I’ve given on this page is correct.' },

    // Actions
    actions: { id: 'actions', defaultMessage: 'Actions' },
    login: { id: 'login', defaultMessage: 'Login' },
    logout: { id: 'logout', defaultMessage: 'Logout' },
    update: { id: 'update', defaultMessage: 'Update' },
    edit: { id: 'edit', defaultMessage: 'Edit' },
    dismiss: { id: 'dismiss', defaultMessage: 'Dismiss' },
    submit: { id: 'submit', defaultMessage: 'Submit' },
    submitted: { id: 'submitted', defaultMessage: 'Submitted' },
    toApprove: { id: 'toApprove', defaultMessage: 'To Approve' },
    submitReview: { id: 'submitReview', defaultMessage: 'Submit Review' },
    submitTimesheet: { id: 'submitTimesheet', defaultMessage: 'Submit weekly timesheet' },
    submitWeeklyInvoice: { id: 'submitWeeklyInvoice', defaultMessage: 'Submit weekly invoice' },
    reviewTimesheetTitle: { id: 'reviewTimesheetTitle', defaultMessage: 'Review your Timesheet' },
    reviewInvoiceTitle: { id: 'reviewInvoiceTitle', defaultMessage: 'Review your Invoice' },
    waiting: { id: 'waiting', defaultMessage: 'Waiting' },
    updateAndSubmitTimesheet: { id: 'submitTimesheet', defaultMessage: 'Update week and Submit' },
    timesheetDetails: { id: 'timesheetDetails', defaultMessage: 'Timesheet details' },
    oldTimesheet: { id: 'oldTimesheet', defaultMessage: 'Cannot make changes to timesheets from past periods.' },
    timesheetWeek: {
        id: 'timesheetWeek',
        defaultMessage: 'Week of {from} - {to}'
    },
    shifts: { id: 'shifts', defaultMessage: 'Shifts' },
    records: { id: 'records', defaultMessage: 'Records' },
    updateShifts: { id: 'updateShifts', defaultMessage: 'Update Shifts' },
    updateTimesheet: { id: 'updateTimesheet', defaultMessage: 'Update Timesheet' },
    totalHours: { id: 'totalHours', defaultMessage: 'Total Hours' },
    noShiftsFound: { id: 'noShiftsFound', defaultMessage: 'No shifts found.' },
    noTimesheetsFound: { id: 'noShiftsFound', defaultMessage: 'No timesheets found.' },
    updateNotes: { id: 'updateNotes', defaultMessage: 'Update notes' },
    add: { id: 'add', defaultMessage: 'Add' },
    ok: { id: 'ok', defaultMessage: 'Ok' },
    or: { id: 'or', defaultMessage: 'Or' },
    go: { id: 'go', defaultMessage: 'Go' },
    cancel: { id: 'cancel', defaultMessage: 'Cancel' },
    canceled: { id: 'canceled', defaultMessage: 'Canceled' },
    back: { id: 'back', defaultMessage: 'Back' },
    nextSteps: { id: 'nextSteps', defaultMessage: 'Next steps' },
    congratulations: { id: 'congratulations', defaultMessage: 'Congratulations' },
    save: { id: 'save', defaultMessage: 'Save' },
    saving: { id: 'saving', defaultMessage: 'Saving ...' },
    saveChanges: { id: 'saveChanges', defaultMessage: 'Save Changes' },
    submitAllTimesheets: { id: 'submitAllTimesheets', defaultMessage: 'Submit all timesheets' },
    approveAllTimesheets: { id: 'approveAllTimesheets', defaultMessage: 'Approve all timesheets' },
    approveAll: { id: 'approveAll', defaultMessage: 'Approve all' },
    reviewApprove: { id: 'reviewApprove', defaultMessage: 'Review & Approve' },
    started: { id: 'started', defaultMessage: 'Started' },
    reject: { id: 'reject', defaultMessage: 'Reject' },
    rejected: { id: 'rejected', defaultMessage: 'Rejected' },
    disputed: { id: 'disputed', defaultMessage: 'Disputed' },
    search: { id: 'search', defaultMessage: 'Search' },
    saveAndContinue: { id: 'saveAndContinue', defaultMessage: 'Save & Continue' },
    allDone: { id: 'allDone', defaultMessage: 'All Done' },
    approve: { id: 'approve', defaultMessage: 'Approve' },
    approveType: { id: 'approveType', defaultMessage: 'Approve {type}' },
    open: { id: 'open', defaultMessage: 'Open' },
    close: { id: 'close', defaultMessage: 'Close' },
    delete: { id: 'delete', defaultMessage: 'Delete' },
    archive: { id: 'archive', defaultMessage: 'Archive' },
    restore: { id: 'restore', defaultMessage: 'Restore' },
    reset: { id: 'reset', defaultMessage: 'Reset' },
    extend: { id: 'extend', defaultMessage: 'Extend' },
    extendWorkersContract: { id: 'extendWorkersContract', defaultMessage: `Extend worker's contract` },
    editWorkersContract: { id: 'editWorkersContract', defaultMessage: `Edit worker's contract` },
    download: { id: 'download', defaultMessage: 'Download' },
    generate: { id: 'generate', defaultMessage: 'Generate' },
    downloadPdf: { id: 'downloadPdf', defaultMessage: 'PDF with instructions' },
    downloadExcel: { id: 'downloadExcel', defaultMessage: 'Download spreadsheet' },
    downloadText: { id: 'downloadText', defaultMessage: 'Download text file' },
    downloadImage: { id: 'downloadImage', defaultMessage: 'Download image' },
    downloadWord: { id: 'downloadWord', defaultMessage: 'Download as Word document' },
    pdfDocument: { id: 'pdfDocument', defaultMessage: 'PDF document' },
    updatingConfirmation: { id: 'updatingConfirmation', defaultMessage: 'Updating {entity}' },
    confirm: { id: 'option.confirm', defaultMessage: 'confirm' },
    yes: { id: 'option.yes', defaultMessage: 'Yes' },
    no: { id: 'option.no', defaultMessage: 'No' },
    noResponse: { id: 'option.null', defaultMessage: 'No response' },
    true: { id: 'option.true', defaultMessage: 'True' },
    false: { id: 'option.false', defaultMessage: 'False' },
    sign: { id: 'sign', defaultMessage: 'Sign' },
    continue: { id: 'continue', defaultMessage: 'Continue' },
    signAndContinue: { id: 'signAndContinue', defaultMessage: 'Sign and Continue' },
    electronicSignature: { id: 'electronicSignature', defaultMessage: 'Electronic Signature' },
    reviewAndSign: { id: 'reviewAndSign', defaultMessage: 'Review and Sign' },
    createContact: { id: 'createContact', defaultMessage: 'Create a new contact' },
    createAddress: { id: 'createAddress', defaultMessage: 'Create a new address record' },
    create: { id: 'create', defaultMessage: 'Create' },
    createSign: { id: 'createSign', defaultMessage: 'Create & Sign' },
    getStarted: { id: 'getStarted', defaultMessage: 'Get Started' },
    signedDocuments: { id: 'signedDocuments', defaultMessage: 'Signed Documents' },
    signatureDate: { id: 'signatureDate', defaultMessage: 'Signature Date' },
    editSignature: { id: 'editSignature', defaultMessage: 'Edit Signature' },
    chooseAStyle: { id: 'chooseAStyle', defaultMessage: 'Choose a style:' },
    choose: { id: 'choose', defaultMessage: 'Choose' },
    addUser: { id: 'addUser', defaultMessage: 'Add user' },
    addAddress: { id: 'addAddress', defaultMessage: 'Add address' },
    clickHere: { id: 'clickHere', defaultMessage: 'Click Here' },

    // File upload
    dragAndDrop: { id: 'dragAndDrop', defaultMessage: '<h4>Drag & Drop</h4><span>your files here or Browse</span>' },
    attachFileOrPhoto: {
        id: 'attachFileOrPhoto',
        defaultMessage: '<h4>Attach Document</h4><br /><span>take a picture of your document or choose one from your library</span>'
    },
    upload: { id: 'upload', defaultMessage: 'Upload' },
    uploadMore: { id: 'upload', defaultMessage: 'Upload another?' },
    uploadFile: { id: 'uploadFile', defaultMessage: 'Upload file' },
    uploadSuccess: { id: 'uploadSuccess', defaultMessage: '{type} successfully uploaded.' },
    attachFile: { id: 'attachFile', defaultMessage: 'Attach {type}' },
    attachAnother: { id: 'attachAnother', defaultMessage: 'Attach another' },
    completed: { id: 'completed', defaultMessage: 'Completed' },
    uploading: { id: 'uploading', defaultMessage: 'Uploading...' },
    unableToRenderDocument: { id: 'unableToRenderDocument', defaultMessage: 'Unable to display document.' },

    // Position
    title: { id: 'title', defaultMessage: 'Title' },
    departmentOpt: { id: 'department', defaultMessage: 'Client/Division/Department' },
    department: { id: 'department', defaultMessage: 'Department' },
    startDate: { id: 'start_date', defaultMessage: 'Start date' },
    starts: { id: 'starts', defaultMessage: 'Starts' },
    endDateOptional: { id: 'end_date_optional', defaultMessage: 'End date (optional)' },
    startDateOptional: { id: 'start_date_optional', defaultMessage: 'Start date (optional)' },
    endDate: { id: 'end_date', defaultMessage: 'End date' },
    trackingNumber: { id: 'trackingNumber', defaultMessage: 'Tracking number' },
    positionDescription: { id: 'positionDescription', defaultMessage: 'Job description / services to be performed' },
    detailedDescription: { id: 'detailedDescription', defaultMessage: 'Detailed description' },
    description: { id: 'description', defaultMessage: 'Description' },
    answered: { id: 'answered', defaultMessage: 'Answered' },
    potential: { id: 'potential', defaultMessage: 'Potential' },
    score: { id: 'score', defaultMessage: 'Score' },
    risk: { id: 'risk', defaultMessage: 'Risk' },
    confidence: { id: 'confidence', defaultMessage: 'Confidence' },
    numberOfQuestions: { id: 'numberOfQuestions', defaultMessage: 'Number of questions: {number}' },
    maxScore: { id: 'maxScore', defaultMessage: 'Max score: {number}' },
    minScore: { id: 'minScore', defaultMessage: 'Min score: {number}' },
    reviewDate: { id: 'reviewDate', defaultMessage: 'Review date: {value}' },
    reviewNote: { id: 'reviewNote', defaultMessage: 'Review note: {value}' },
    reviewer: { id: 'reviewer', defaultMessage: 'Reviewer: {value}' },
    scoreAdjust: { id: 'scoreAdjust', defaultMessage: 'Score adjust: {value}' },
    reviewStatus: { id: 'reviewStatus', defaultMessage: 'Status: {value}' },
    classification: { id: 'classification', defaultMessage: 'Classification' },
    icw2: { id: 'icw2', defaultMessage: 'IC/EE' },
    classifications: { id: 'classifications', defaultMessage: 'Classifications' },
    questionnaire: { id: 'questionnaire', defaultMessage: 'Questionnaire' },
    clientClassification: { id: 'clientClassification', defaultMessage: 'Client classification' },
    workerPreClassification: { id: 'workerPreClassification', defaultMessage: 'Worker preclassification' },
    proposedClassification: { id: 'proposedClassification', defaultMessage: 'Proposed Classification' },
    proposed: { id: 'proposed', defaultMessage: 'Proposed' },
    classifyResult: { id: 'classifyResult', defaultMessage: 'Classification Result' },
    workerClassification: { id: 'workerClassification', defaultMessage: 'Worker Classification' },
    classifyClientPreference: { id: 'classifyClientPreference', defaultMessage: 'Classification Preference (Employee/Contractor)' },
    determinedClassification: { id: 'determinedClassification', defaultMessage: 'Determined classification' },
    workerClassificationPreference: { id: 'workerClassificationPreference', defaultMessage: 'Worker Classification Preference' },
    clientClassificationPreference: { id: 'clientClassificationPreference', defaultMessage: 'Client Classification Preference' },
    jobs: { id: 'jobs', defaultMessage: 'Jobs' },
    jobCharacteristics: { id: 'jobCharacteristics', defaultMessage: 'Job Characteristics' },
    paymentType: { id: 'paymentType', defaultMessage: 'Payment type' },
    payRate: { id: 'payRate', defaultMessage: 'Hourly rate' },
    rate: { id: 'rate', defaultMessage: 'Rate' },
    billRate: { id: 'billRate', defaultMessage: 'Bill Rate' },
    totalValue: { id: 'totalValue', defaultMessage: 'Contract value' },
    purchaseOrder: { id: 'purchaseOrder', defaultMessage: 'Purchase order' },
    purchaseOrders: { id: 'purchaseOrders', defaultMessage: 'Purchase Orders' },
    poWhen: { id: 'poWhen', defaultMessage: 'Purchase order status' },
    poNumber: { id: 'poNumber', defaultMessage: 'Purchase order number' },
    poValue: { id: 'poValue', defaultMessage: 'Purchase order value' },
    poDate: { id: 'poDate', defaultMessage: 'Purchase order date' },
    worker: { id: 'worker', defaultMessage: 'Worker' },
    currentAssignment: { id: 'currentAssignment', defaultMessage: 'Current Assignment' },
    completedAssignment: { id: 'completedAssignment', defaultMessage: 'Completed Assignment' },
    pendingAssignment: { id: 'pendingAssignment', defaultMessage: 'Pending Assignment' },
    assignment: { id: 'assignment', defaultMessage: 'Assignment' },
    workers: { id: 'workers', defaultMessage: 'Workers' },
    active: { id: 'active', defaultMessage: 'Active' },
    inactive: { id: 'inactive', defaultMessage: 'Inactive' },
    approver: { id: 'approver', defaultMessage: 'Approver' },
    workerNotes: { id: 'workerNotes', defaultMessage: 'Worker Notes' },
    approverNotes: { id: 'approverNotes', defaultMessage: 'Approver Notes' },
    confirmation: { id: 'confirmation', defaultMessage: 'Are you sure ?' },
    confirmed: { id: 'confirmed', defaultMessage: 'Confirmed' },
    notConfirmed: { id: 'notConfirmed', defaultMessage: 'Not Confirmed' },
    incompatibleTitle: { id: 'incompatibleTitle', defaultMessage: 'Note' },
    incompatibleMessage: {
        id: 'incompatibleMessage',
        defaultMessage: `You specified 'Independent Contractor if possible, else employee'.<br /><br />
            Based on what you've told us about the degree of control you will exert over the worker,
            employee is the appropriate status for this position.`
    },
    incompatibleMessageIConly: {
        id: 'incompatibleMessageIConly',
        defaultMessage: `You specified 'Independent Contractor only'.<br /><br />
            Based on what you've told us about the degree of control you will exert over the worker,
            this position does not qualify for Independent Contractor status.<br />`
    },
    incompatibleMessageIConlyChangeW2: {
        id: 'incompatibleMessageIConlyChangeW2',
        defaultMessage: `If you want to proceed with this worker, please change to 'Employee' and continue.`
    },
    incompatibleMessageIConlyPolicy: {
        id: 'incompatibleMessageIConlyPolicy',
        defaultMessage: `Your company policy does not permit selecting 'Employee'.  Please contact your account manager.`
    },

    theWork: { id: 'theWork', defaultMessage: 'Assignment Details' },
    thePay: { id: 'thePay', defaultMessage: 'Payment & Billing' },

    workLocation: { id: 'workLocation', defaultMessage: 'Work location' },
    location: { id: 'location', defaultMessage: 'Location' },
    states: { id: 'states', defaultMessage: 'States' },
    locationGroup: { id: 'locationGroup', defaultMessage: 'Location Group' },
    workLocationRemote: { id: 'workLocationRemote', defaultMessage: 'Remote' },
    workLocationAtYourLocation: { id: 'workLocationAtYourLocation', defaultMessage: 'Remote' },
    workLocationAtWorkerLocation: { id: 'workLocationAtWorkerLocation', defaultMessage: "At worker's location" },
    workLocationOnSite: { id: 'workLocationOnSite', defaultMessage: 'On Site' },
    workTimezone: { id: 'workTimezone', defaultMessage: 'Work Timezone' },
    reportingTo: { id: 'reportingTo', defaultMessage: 'Reporting to' },
    apContact: { id: 'apContact', defaultMessage: 'AP Contact' },
    assignmentDetails: { id: 'assignmentDetails', defaultMessage: 'Assignment details' },

    hoursPerWeekOptional: { id: 'hoursPerWeek', defaultMessage: 'Est hours/week' },
    hoursPerWeek: { id: 'hoursPerWeek', defaultMessage: 'Estimated hours/week' },
    whatIsPrimary: { id: 'whatIsPrimary', defaultMessage: 'The primary work site is:' },
    onsite: { id: 'onsite', defaultMessage: 'Onsite at a company location' },
    offsite: { id: 'offsite', defaultMessage: "Offsite at worker's location" },
    isIC: { id: 'isIC', defaultMessage: 'Is independent contractor ?' },
    pointOfContact: { id: 'pointOfContact', defaultMessage: 'Point Of Contact' },
    primaryContact: { id: 'pointOfContact.primaryContact', defaultMessage: 'Primary Contact' },
    managerOrSupervisor: { id: 'managerOrSupervisor', defaultMessage: 'Manager/Supervisor' },
    backupTimeApprover: { id: 'pointOfContact.backupTimeApprover', defaultMessage: "Worker's time approve manager" },

    // Timekeeping
    project: { id: 'project', defaultMessage: 'Project' },
    projects: { id: 'projects', defaultMessage: 'Projects' },
    addProject: { id: 'project', defaultMessage: '+ Add Project' },
    addProjectTitle: { id: 'project', defaultMessage: 'Add Project' },
    editProjectTitle: { id: 'project', defaultMessage: 'Edit Project' },
    projectTask: { id: 'projectTask', defaultMessage: 'Project / Task' },
    startTime: { id: 'startTime', defaultMessage: 'Started at' },
    endTime: { id: 'endTime', defaultMessage: 'Ended at' },
    duration: { id: 'duration', defaultMessage: 'Duration' },
    notes: { id: 'notes', defaultMessage: 'Notes' },
    goBackAndEdit: { id: 'goBackAndEdit', defaultMessage: 'Go back and edit' },
    addSessions: { id: 'addSession', defaultMessage: 'Add work or break sessions' },
    addSession: { id: 'addSession', defaultMessage: 'Add session' },
    addAnouterSession: { id: 'addAnouterSession', defaultMessage: '+ Add another session' },
    addNewSession: { id: 'addNewSession', defaultMessage: '+ Add session' },
    copySessions: { id: 'copySessions', defaultMessage: '+ Copy previous day' },
    weekendWork: { id: 'copySessions', defaultMessage: '+ Add weekend hours' },
    break: { id: 'break', defaultMessage: 'Break' },
    nextDay: { id: 'nextDay', defaultMessage: 'Next day' },
    previousDay: { id: 'previousDay', defaultMessage: 'Previous day' },
    happyFriday: { id: 'previousDay', defaultMessage: 'Happy Friday' },
    submittingWarning: {
        id: 'submittingWarning',
        defaultMessage: 'By submitting this timesheet, I declare that all its contents are truthful.'
    },
    seeTimesheets: { id: 'seeTimesheets', defaultMessage: 'See Timesheets' },
    seeInvoices: { id: 'seeInvoices', defaultMessage: 'See Invoices' },
    deliverables: { id: 'deliverables', defaultMessage: 'Deliverables/Adjustments' },
    addDeliverable: { id: 'addDeliverable', defaultMessage: '+ Add Deliverable' },
    addDeliverableTitle: { id: 'addDeliverable', defaultMessage: 'Add Deliverable' },
    editDeliverableTitle: { id: 'addDeliverable', defaultMessage: 'Edit Deliverable' },
    removeDeliverableConfirmation: { id: 'addDeliverable', defaultMessage: 'Item will be removed. Are you sure ?' },
    addExpense: { id: 'addDeliverable', defaultMessage: '+ Add Expense' },
    addExpenseTitle: { id: 'addDeliverable', defaultMessage: 'Add Expense' },
    editExpenseTitle: { id: 'addDeliverable', defaultMessage: 'Edit Expense' },
    expenses: { id: 'expenses', defaultMessage: 'Expenses' },
    plusExpenses: { id: '+expenses', defaultMessage: '+ expenses' },
    plusDeliverables: { id: '+deliverables', defaultMessage: '+ deliverables' },
    plusDeliverablesAndExpenses: { id: '+deliverables+expenses', defaultMessage: '+ deliverables & expenses' },

    // Onboarding
    startOnboarding: { id: 'startOnboarding', defaultMessage: 'Get Started' },
    continueOnboarding: { id: 'continueOnboarding', defaultMessage: 'Continue Onboarding' },
    prequalifyInsurance: {
        id: 'prequalify.insurance1',
        defaultMessage: "I have or will obtain general liability, errors and omissions, and worker's compensation insurance."
    },
    backgroundCheck: { id: 'backgroundCheck', defaultMessage: 'Background Check' },
    welcomeBack: { id: 'welcomeBack', defaultMessage: 'Welcome Back' },
    directDeposit: { id: 'directDeposit', defaultMessage: 'Direct Deposit' },
    w4: { id: 'w4', defaultMessage: 'W-4' },
    w9: { id: 'w9', defaultMessage: 'W-9' },
    newStaterInfo: { id: 'newStaterInfo', defaultMessage: 'New starter checklist' },
    employeeHandbook: { id: 'employeeHandbook', defaultMessage: 'Employee Handbook' },
    insuranceAndBenefits: { id: 'insuranceAndBenefits', defaultMessage: 'Insurance And Benefits' },
    pensionContribution: { id: 'pensionContribution', defaultMessage: 'Pension Contribution' },
    rightToWork: { id: 'rightToWork', defaultMessage: 'Right To Work' },
    i9Registration: { id: 'i9Registration', defaultMessage: 'US Employment Eligibility (I-9)' },
    i9Registration2: { id: 'i9Registration2', defaultMessage: 'I-9 (continued)' },
    contractorCompanyInfo: { id: 'contractorCompanyInfo', defaultMessage: 'Tell us about your business' },
    contractorICClassification: { id: 'contractorICClassification', defaultMessage: 'IC Classification' },
    insuranceRequirements: { id: 'insuranceRequirements', defaultMessage: 'Insurance Requirements' },
    documentUpload: { id: 'documentUpload', defaultMessage: 'Document Upload' },
    promisedDocumentUpload: { id: 'documentUpload', defaultMessage: 'Complete IC Documents' },
    uploadAndFinishIC: { id: 'uploadAndFinishIC', defaultMessage: 'Upload Documents and Submit' },
    taxDocuments: { id: 'taxDocuments', defaultMessage: 'Tax Documents' },
    prequalifyOnlyClient: { id: 'prequalify.onlyClient', defaultMessage: '{co} will be my only client.' },
    prequalifyOwnHours: { id: 'prequalify.ownHours', defaultMessage: 'I will determine my own <strong>hours</strong> and <strong>work location</strong>.' },
    prequalifyOnsite: { id: 'prequalify.onsite', defaultMessage: 'I plan to work <strong>onsite</strong> at {co} using <strong>their</strong> equipment.' },
    prequalifyDirected: { id: 'prequalify.directed', defaultMessage: 'I will be directed by {co} on <strong>how</strong> to do my work.' },
    prequalifyResources: { id: 'prequalify.resources', defaultMessage: 'I can provide all resources necessary on the job.' },
    prequalifyOtherClients: { id: 'prequalify.otherClients', defaultMessage: 'I will have client(s) <strong>other than</strong> {co} during this assignment.' },
    prequalifyNotEmployee: { id: 'prequalify.notEmployee', defaultMessage: 'I have <strong>not</strong> been an employee of {co} in the last 13 months.' },
    contractPeriod: { id: 'contractPeriod', defaultMessage: 'Contract Period' },
    contractType: { id: 'contractType', defaultMessage: 'Contract Type' },
    contractValue: { id: 'contractValue', defaultMessage: 'Contract Value' },
    offerLetter: { id: 'offerLetter', defaultMessage: 'Offer Letter' },
    contractorAgreement: { id: 'contractorAgreement', defaultMessage: 'Independent Service Provider Agreement' },
    assignmentLetter: { id: 'assignmentLetter', defaultMessage: 'Assignment Letter' },
    w4FillingStatus: { id: 'w4FillingStatus', defaultMessage: 'Filing Status' },
    w4TotalAllowances: { id: 'w4TotalAllowances', defaultMessage: 'Total Allowances' },
    w4TotalAllowancesExplanation: { id: 'w4TotalAllowancesExplanation', defaultMessage: 'Total Allowances means ...' },
    w4AdditionalWithholding: { id: 'w4AdditionalWithholding', defaultMessage: 'Additional Withholding (optional)' },
    i9ChoicesLabel: { id: 'i9ChoicesLabel', defaultMessage: 'I attest, under penalty of perjury, that I am (check one of the following boxes):' },
    alienRegistrationOrUSCISNumber: { id: 'alienRegistrationNumber', defaultMessage: 'Alien Registration Number/USCIS Number' },
    alienRegistrationNumber: { id: 'alienRegistrationNumber', defaultMessage: 'Alien Registration Number' },
    alienUSCISNumber: { id: 'alienRegistrationNumber', defaultMessage: 'USCIS Number' },
    visaType: { id: 'visaType', defaultMessage: 'Visa type' },
    visaStartDate: { id: 'visaStartDate', defaultMessage: 'Visa start date' },
    permitExpirationDate: { id: 'permitExpirationDate', defaultMessage: 'Expiration date' },
    formI94AdmissionNumber: { id: 'formI94AdmissionNumber', defaultMessage: 'Form I-94 Admission Number' },
    foreignPassportNumber: { id: 'foreignPassportNumber', defaultMessage: 'Foreign Passport Number' },
    foreignPassportCountry: { id: 'foreignPassportCountry', defaultMessage: 'Country of Issuance' },
    basic: { id: 'basic', defaultMessage: 'Basic' },
    enhanced: { id: 'enhanced', defaultMessage: 'Enhanced' },
    coTypeCorporation: { id: 'coTypeCorporation', defaultMessage: 'Corporation' },
    coTypeLLC: { id: 'coTypeLLC', defaultMessage: 'LLC' },
    coTypePartnership: { id: 'coTypePartnership', defaultMessage: 'Partnership' },
    coTypeSoleProp: { id: 'coTypeSoleProp', defaultMessage: 'Sole Proprietorship' },
    coTypeOther: { id: 'coTypeOther', defaultMessage: 'Other' },
    companyPolicyDocumentsExplanation: {
        id: 'companyPolicyDocumentsExplanation',
        defaultMessage:
            "<p>If {client} has its own policy documents we should use in engaging workers, upload them here. An administrator from {admin} will review them and, after approval, we will apply them to all workers you hire through us.</p><p>If you don't upload a document for any of these categories, our standard policies will apply.</p>"
    },
    employeeStatement: {
        id: 'employeeStatement',
        defaultMessage: 'Employee Statement'
    },
    employeeStatementLabel: {
        id: 'employeeStatementLabel',
        defaultMessage: ' Please select the option which is applicable to you:'
    },
    employeeStatementFirst: {
        id: 'employeeStatementFirst',
        defaultMessage:
            ' This is my first job since 6 April and I’ve not been receiving taxable Jobseeker’s Allowance, Employment and Support Allowance, taxable Incapacity Benefit, State or Occupational Pension.'
    },
    employeeStatementAnother: {
        id: 'employeeStatementAnother',
        defaultMessage:
            ' This is now my only job but since 6 April I’ve had another job, or received taxable Jobseeker’s Allowance, Employment and Support Allowance or taxable Incapacity Benefit. I do not receive a State or Occupational Pension.'
    },
    employeeStatementOther: {
        id: 'employeeStatementOther',
        defaultMessage: ' As well as my new job, I have another job or receive a State or Occupational Pension.'
    },
    previousEmployment: { id: 'previousEmployment', defaultMessage: 'Previous employment' },
    studentLoan: { id: 'studentLoan', defaultMessage: 'Student Loan' },
    postgraduateLoan: { id: 'postgraduateLoan', defaultMessage: 'Postgraduate Loan' },
    underReviewTitle: { id: 'underReviewTitle', defaultMessage: 'Under Review.' },
    createdAccount: { id: 'createdAccount', defaultMessage: 'Created account' },
    submittedBusinessDocs: { id: 'submittedBusinessDocs', defaultMessage: 'Submitted business documents' },
    approvalUnderway: { id: 'approvalUnderway', defaultMessage: '{admin} review' },
    contactingEmployer: { id: 'contactingEmployer', defaultMessage: 'Contacting {client}' },
    signICAgreement: { id: 'signICAgreement', defaultMessage: 'E-sign contractor agreements' },
    approvedToStart: { id: 'approvedToStart', defaultMessage: 'Approved to start' },
    reason: { id: 'reason', defaultMessage: 'Reason' },
    comment: { id: 'comment', defaultMessage: 'Comment' },
    submitHelpRequest: { id: 'sumbitHelpRequest', defaultMessage: 'Submit help request' },
    chooseTypeStepDescription: {
        id: 'chooseTypeStepDescription',
        defaultMessage:
            "Acme Inc believes you should be paid as a business.  It's our job to verify whether that treatment is consistent with state and federal regulations."
    },

    // Banking
    banking: { id: 'banking', defaultMessage: 'Banking' },
    bankName: { id: 'bankName', defaultMessage: 'Bank Name' },
    bankRouting: { id: 'bankRouting', defaultMessage: 'Bank Routing Number' },
    sortCode: { id: 'sortCode', defaultMessage: 'Sort Code' },
    checkingAccount: { id: 'checkingAccount', defaultMessage: 'Checking Account Number' },
    ukCheckingAccount: { id: 'ukCheckingAccount', defaultMessage: 'Account Number' },
    noBankAccount: { id: 'noBankAccount', defaultMessage: 'Paper check requested' },
    bankingCheckPreference: { id: 'bankingCheckPreference', defaultMessage: 'I prefer to have checks mailed to my address (not recommended).' },

    // Document types
    docNDA: { id: 'docNDA', defaultMessage: 'Non-disclosure Agreement (NDA)' },
    docAdminMSA: { id: 'docAdminMSA', defaultMessage: 'GreenLight MSA' },
    docAdminW4: { id: 'docAdminW4', defaultMessage: 'W-4 Tax Form' },
    docAdminI9: { id: 'docAdminI9', defaultMessage: 'I-9 Form' },
    docAdminW9: { id: 'docAdminW9', defaultMessage: 'W-9 Tax Form' },
    docAdminEHandbook: { id: 'docAdminEHandbook', defaultMessage: 'GreenLight Employee Handbook' },
    docAdminEContract: { id: 'docAdminEContract', defaultMessage: 'GreenLight Employee Contract' },
    docAdminICAgreement: { id: 'docAdminICAgreement', defaultMessage: 'GreenLight Independent Contractor Agreement' },

    // Other documents
    i9: { id: 'i9form', defaultMessage: 'I-9 Form' },
    docSignedI9: { id: 'docSignedI9', defaultMessage: 'Signed I-9 Form' },
    clientSpecificDocs: { id: 'clientSpecificDocs', defaultMessage: 'Client-specific documents' },
    otherDocuments: { id: 'otherDocuments', defaultMessage: 'Other Documents' },
    docGovernmentIssuedId: { id: 'docGovernmentIssuedId', defaultMessage: 'US Employment Eligibility document(s) that you selected on form I-9' },

    // Witness flow
    witnessBusinessName: { id: 'witnessBusinessName', defaultMessage: 'Your company name' },
    witnessJobTitle: { id: 'witnessJobTItle', defaultMessage: 'Your job title' },
    witnessBusinessAddress: { id: 'yourJobAddress', defaultMessage: 'Your work address' },
    witnessDate: { id: 'witnessDate', defaultMessage: 'Date witnessed' },
    jobTitle: { id: 'jobTitle', defaultMessage: 'Job Title' },

    // Invoices
    invoices: { id: 'invoices', defaultMessage: 'Invoices' },
    invoicing: { id: 'invoicing', defaultMessage: 'Invoicing' },
    currentPeriod: { id: 'currentPeriod', defaultMessage: 'Current Week' },
    priorPeriods: { id: 'priorPeriods', defaultMessage: 'All Weeks' },
    invoice: { id: 'invoice', defaultMessage: 'Invoice' },
    invoiceDate: { id: 'invoiceDate', defaultMessage: 'Invoice date' },
    invoiceNumber: { id: 'invoiceNumber', defaultMessage: 'Invoice #' },

    // Payrolls
    payrollDate: { id: 'payrollDate', defaultMessage: 'Payroll date' },

    // Misc text
    alerts: { id: 'alerts', defaultMessage: 'Alerts' },
    finish: { id: 'finish', defaultMessage: 'Finish' },
    urgent: { id: 'urgent', defaultMessage: 'Urgent' },
    remove: { id: 'remove', defaultMessage: 'Remove' },
    general: { id: 'general', defaultMessage: 'General' },
    documents: { id: 'documents', defaultMessage: 'Documents' },
    personalDocuments: { id: 'personalDocuments', defaultMessage: 'Personal Documents' },
    contractorGlobalDocs: { id: 'contractorGlobalDocs', defaultMessage: 'Policy Documents' },
    payStubs: { id: 'payStubs', defaultMessage: 'Pay Stubs' },
    pay: { id: 'pay', defaultMessage: 'Pay' },
    documentId: { id: 'documentId', defaultMessage: 'Document #' },
    documentType: { id: 'documentType', defaultMessage: 'Document type' },
    timesheet: { id: 'timesheet', defaultMessage: 'Timesheet' },
    timesheets: { id: 'timesheets', defaultMessage: 'Timesheets' },
    priorTimesheets: { id: 'priorTimesheets', defaultMessage: 'Prior Timesheets' },
    timekeeping: { id: 'timekeeping', defaultMessage: 'Timekeeping' },
    addLater: { id: 'addLater', defaultMessage: 'Add this information later.' },
    change: { id: 'change', defaultMessage: 'Change' },
    submitLater: { id: 'submitLater', defaultMessage: 'Submit later' },
    willSubmitLater: { id: 'willSubmitLater', defaultMessage: 'Will submit later' },
    dontHave: { id: 'dontHave', defaultMessage: `Don't have` },
    dontHaveDocument: { id: 'dontHaveDocument', defaultMessage: `Don't have this document` },
    currency: { id: 'currency', defaultMessage: 'Currency' },
    currencyShort: { id: 'currencyShort', defaultMessage: '$£€' },
    user: { id: 'user', defaultMessage: 'User' },
    users: { id: 'users', defaultMessage: 'Users' },
    review: { id: 'review', defaultMessage: 'Review' },
    createFeeRule: { id: 'createFeeRule', defaultMessage: 'Create Fee Rule' },
    fee: { id: 'fee', defaultMessage: 'Fee' },
    threshold: { id: 'threshold', defaultMessage: 'Threshold' },
    rateThreshold: { id: 'rateThreshold', defaultMessage: 'Rate >=' },
    fees: { id: 'fees', defaultMessage: 'Fees' },
    priority: { id: 'priority', defaultMessage: 'Priority' },
    weight: { id: 'weight', defaultMessage: 'Weight' },
    as: { id: 'as', defaultMessage: 'as' },
    validSince: { id: 'validSince', defaultMessage: 'Valid Since' },
    validSinceDate: { id: 'validSinceDate', defaultMessage: 'Valid Since {date}' },
    validUntil: { id: 'validUntil', defaultMessage: 'Valid Until' },
    validUntilDate: { id: 'validUntilDate', defaultMessage: 'Valid Until {date}' },
    reviewTimesheet: { id: 'reviewTimesheet', defaultMessage: 'Review Timesheet' },
    reviseTimesheet: { id: 'reviseTimesheet', defaultMessage: 'Revise timesheet as requested by manager' },
    invites: { id: 'invites', defaultMessage: 'Invites' },
    invited: { id: 'invited', defaultMessage: 'Invited' },
    contractorExists: { id: 'contractorExists', defaultMessage: 'An account with this email address exists already' },
    inviteDate: { id: 'inviteDate', defaultMessage: 'Invite Date' },
    inviteWorker: { id: 'inviteUser', defaultMessage: 'Invite Worker' },
    inviteUser: { id: 'inviteUser', defaultMessage: 'Invite User' },
    inviteResent: { id: 'inviteResent', defaultMessage: 'Invite re-sent!' },
    inviteWitness: { id: 'inviteWitness', defaultMessage: 'Invite I9 Witness' },
    inviteClient: { id: 'inviteClient', defaultMessage: 'Invite New Client' },
    updateUserInvite: { id: 'updateUserInvite', defaultMessage: 'Update User Invitation' },
    inviteSuccess: { id: 'inviteSuccess', defaultMessage: '{name} successfully invited.' },
    postSuccess: { id: 'postSuccess', defaultMessage: '{name} successfully posted.' },
    updateSuccess: { id: 'updateSuccess', defaultMessage: '{name} successfully updated.' },
    expiring: { id: 'expiring', defaultMessage: 'Expiring' },
    total: { id: 'total', defaultMessage: 'Total' },
    exceptions: { id: 'exceptions', defaultMessage: 'Exceptions' },
    complete: { id: 'complete', defaultMessage: 'Complete' },
    registered: { id: 'registered', defaultMessage: 'Registered' },
    underReview: { id: 'underReview', defaultMessage: 'Under Review' },
    pending: { id: 'pending', defaultMessage: 'Pending' },
    progress: { id: 'progress', defaultMessage: 'Progress' },
    approved: { id: 'approved', defaultMessage: 'Approved' },
    notApproved: { id: 'notApproved', defaultMessage: 'Not Approved' },
    returned: { id: 'returned', defaultMessage: 'Returned' },
    createdAt: { id: 'createdAt', defaultMessage: 'Created At' },
    updatedAt: { id: 'updatedAt', defaultMessage: 'Updated At' },
    submittedOn: { id: 'submittedOn', defaultMessage: 'Submitted On' },
    periodEnding: { id: 'periodEnding', defaultMessage: 'Period Ending' },
    ongoing: { id: 'ongoing', defaultMessage: 'Ongoing' },
    noPo: { id: 'noPo', defaultMessage: 'No PO' },
    noWorkers: { id: 'noWorkers', defaultMessage: 'No workers found.' },
    noOnboardingWorkers: { id: 'noOnboardingWorkers', defaultMessage: 'No onboarding workers found.' },
    onboardingWorkers: { id: 'onboardingWorkers', defaultMessage: 'Onboarding workers' },
    workerExpirations: { id: 'workerExpirations', defaultMessage: 'Expiring contracts' },
    notProvided: { id: 'notProvided', defaultMessage: 'Not provided' },
    fromto: {
        id: 'fromto',
        defaultMessage: '{from} - {to}'
    },
    seeAssignmentStatus: {
        id: 'seeAssignmentStatus',
        defaultMessage: 'See your assignment status'
    },
    assignmentUnderReview: {
        id: 'assignmentUnderReview',
        defaultMessage: 'Assignment has yet to start'
    },
    /*    timeOnceAccepted: {
        id: 'timeOnceAccepted',
        defaultMessage:
            'Your information is under review. Once it is approved and your assignment starts, you will be able to submit timesheets or invoices here.'
    },*/
    /*    timeOnceStarted: {
        id: 'timeOnceStarted',
        defaultMessage: 'After your assignment starts you will be able to submit timesheets or invoices here.'
    },*/
    timeJobInactive: {
        id: 'timeJobInactive',
        defaultMessage: 'Your assignment has completed.  If you have additional time to enter, please email hr@greenlight.ai.'
    },
    noPayYet: {
        id: 'noPayYet',
        defaultMessage: 'After your first paycheck you will be able to see your earnings here.'
    },
    timesheetConfirmed: { id: 'timesheetSubmitted', defaultMessage: 'Timesheet for this period is already confirmed.' },
    timesheetNotApproved: {
        id: 'timesheetNotApproved',
        defaultMessage: 'Your manager has sent back your timesheet with comments. Please review, correct and resubmit.'
    },
    timesheetSubmitted: { id: 'timesheetSubmitted', defaultMessage: 'Timesheet for this period is already submitted.' },
    timesheetPendingExists: { id: 'timesheetPendingExists', defaultMessage: "This week's timesheet will be open beginning Monday afternoon." },
    iAgreeToTerms: { id: 'iAgreeToTerms', defaultMessage: 'I accept the GreenLight Terms and Conditions.' },
    iAgree: { id: 'iAgree', defaultMessage: 'I acknowledge that I understand this policy.' },
    iAgreeToDocument: {
        id: 'iAgreeToDocument',
        defaultMessage: 'I acknowledge that I have been provided the {admin} Employee Handbook and I agree to be bound by its terms and conditions.'
    },
    additionalDocsIAgree: { id: 'additionalDocs.mustAgree', defaultMessage: 'I certify that I have read the above documents.' },
    billingIntroText: {
        id: 'billing.introText',
        defaultMessage:
            "<p>To pay your workers promptly, {biller} will debit the approved amount from {co}'s bank account automatically ahead of each payroll, just as other payroll services do.</p><p>Please enter your banking information below. {biller} will conduct an ACH check to confirm we can transact directly.</p>"
    },
    issuingAuthority: { id: 'issuingAuthority', defaultMessage: 'Issuing Authority' },
    docNumber: { id: 'docNumber', defaultMessage: 'Document Number' },
    expirationDate: { id: 'expirationDate', defaultMessage: 'Expires' },
    consumed: { id: 'consumed', defaultMessage: 'Consumed' },
    chooseClient: { id: 'chooseClient', defaultMessage: 'Choose client' },
    loadingRoles: { id: 'loadingRoles', defaultMessage: 'Loading profile details ...' },
    loadingRequirements: { id: 'loadingRequirements', defaultMessage: 'Loading requirements ...' },
    fileUpload: { id: 'fileUpload', defaultMessage: 'Upload {type}' },
    signatureAndArbitration: { id: 'signatureAndArbitration', defaultMessage: 'Arbitration Agreement' },
    personalInformation: { id: 'personalInformation', defaultMessage: 'Personal Information' },
    companyInformation: { id: 'companyInformation', defaultMessage: 'Company Information' },
    companyBillingAndAch: { id: 'companyBillingAndAch', defaultMessage: 'Billing and ACH' },
    companyProgramPolicies: { id: 'companyProgramPolicies', defaultMessage: 'Program Policies' },
    contactInformation: { id: 'contactInformation', defaultMessage: 'Contact Information' },
    iWorkFromThisAddress: { id: 'iWorkFromThisAddress', defaultMessage: 'I work from this address.' },
    icWaiveInsurance: { id: 'icWaiveInsurance', defaultMessage: 'Waive requirement for Independent Contractor Insurance' },
    icNoInsurance: { id: 'icNoInsurance', defaultMessage: `I don't (yet) have business insurance` },
    backgroundCheckType: { id: 'backgroundCheckType', defaultMessage: 'Background check type' },
    backgroundCheckProgress: {
        id: 'backgroundCheckProgress',
        defaultMessage: 'Background check ({progress} of {total})'
    },
    agreeToBackgroundCheck: { id: 'agreeToBackgroundCheck', defaultMessage: 'I consent to a background check.' },
    acknowledgeFCRA: {
        id: 'acknowledgeFCRA',
        defaultMessage:
            'I acknowledge receipt of the Summary of Your Rights Under the Fair Credit Reporting Act (FCRA) and certify that I have read and understand this document.'
    },
    acknowledgeDRB: {
        id: 'acknowledgeDRB',
        defaultMessage: 'I acknowledge receipt of the Disclosure Regarding Background Investigation and certify that I have read and understand this document.'
    },
    acknowledgeCDRB: {
        id: 'acknowledgeCDRB',
        defaultMessage: 'I acknowledge receipt of the California Disclosure and certify that I have read and understand this document.'
    },
    acknowledgeCDRBGetCopy: { id: 'acknowledgeCDRBGetCopy', defaultMessage: 'Please check this box if you would like to receive a copy of a consumer report.' },
    acknowledgeAuthorizationGetCopy: {
        id: 'acknowledgeAuthorizationGetCopy',
        defaultMessage: 'Please check this box if you would like to receive a copy of a consumer report.'
    },
    acknowledgeAuthorization: {
        id: 'acknowledgeAuthorization',
        defaultMessage: 'By clicking "SIGN" below, I consent to the background checks and indicate my agreement to all of the above.'
    },
    clientRequiresBackgroundCheck: {
        id: 'clientRequiresBackgroundCheck',
        defaultMessage: 'Check here if {client} requires workers to undergo a background check.'
    },
    clientRequiresDrugCheck: { id: 'clientRequiresDrugCheck', defaultMessage: 'Check here if {client} requires workers to undergo drug screening.' },
    clientRequiresIndividualPO: {
        id: 'clientRequiresIndividualPO',
        defaultMessage: 'Does your program require a separate purchase order for each worker we engage for you?'
    },
    acknowledgeOfferLetter: {
        id: 'acknowledgeOfferLetter',
        defaultMessage:
            'I have read the terms and conditions above.  By e-signing, I knowingly and voluntarily enter into an at-will employment relationship on the terms and conditions stated in this Offer Letter.'
    },
    clientW2ICexplanation: {
        id: 'clientW2ICexplanation',
        defaultMessage:
            'Each time your company creates a position and invites a worker, you can indicate a preference for that worker to be evaluated as an employee or Independent Contractor.  If you do not want this flexibility, because your program only includes one type of classification, check one of the boxes below.'
    },
    clientW2Only: {
        id: 'clientW2Only',
        defaultMessage: 'Check here if your company requires that all workers be employed on your behalf.'
    },
    clientICOnly: {
        id: 'clientICOnly',
        defaultMessage: 'Check here if your company requires that all workers be engaged as Independent Contractors.'
    },

    clientAllowsICExplanation: {
        id: 'clientAllowsICExplanation',
        defaultMessage:
            '<p>In an effort to protect {client} and to minimize the risk that {admin} takes on, we have requirements all Independent Contractors must meet.</p><p>All prospective Independent Contractors will be required to provide proof of business and carry insurances.</p><p>The default minimum requirements are as follows:<ul><li>General liability coverage of $2,000,000</li><li>Errors & Omissions coverage of $1,000,000</li><li>Auto liability coverage of $1,000,000</li><li>Workers compensation coverage of $1,000,000</li></ul></p><p>To set higher insurance requirements, contact your {admin} account representative.</p>'
    },
    documentDisclaimer: {
        id: 'workerContract.finePrint',
        defaultMessage:
            '<p>This is a legal document. Please review carefully. Be sure that you are satisfied with the language and terms of your contract. You can download a copy of the document either before or after signing it.</p>'
    },
    toBringList: {
        id: 'nextSteps.toBringList',
        defaultMessage: '{type} required forms of identification.<br />You can view requirements <a href="{link}">here</a>.'
    },
    selectFieldDefaultOption: { id: 'selectFieldDefaultOption', defaultMessage: 'None' },
    onboardingW2Congrats: {
        id: 'job.onboardingCongratulations.w2',
        defaultMessage:
            "You're all done with onboarding - congratulations!  Your background check is under way; it should take between 3 and 7 business days to complete, after which we'll notify you and your manager that you're good to go."
    },
    onboardingICCongrats: {
        id: 'job.onboardingCongratulations.ic',
        defaultMessage: "You're all done with onboarding - congratulations!"
    },
    ohNo: { id: 'ohNo', defaultMessage: 'Oh no!' },

    // Dashboard circles states
    // Circle 1
    acceptedInvitation: { id: 'acceptedInvitation', defaultMessage: 'Accepted Invitation' },
    notYetAcceptedInvitation: { id: 'notYetAcceptedInvitation', defaultMessage: 'Invitation not yet accepted' },
    invitationSent: { id: 'invitationSent', defaultMessage: 'Invitation Sent' },
    invitationNotDelivered: { id: 'invitationNotDelivered', defaultMessage: 'Invitation Not Delivered' },
    invitationDelivered: { id: 'invitationDelivered', defaultMessage: 'Invitation Delivered' },
    invitationBounced: { id: 'invitationBounced', defaultMessage: 'Invitation Bounced' },
    // Circle 2
    onboardingComplete: { id: 'employeeOnboardingComplete', defaultMessage: '{type} onboarding complete' },
    onboardingNotStarted: { id: 'employeeOnboardingNotStarted', defaultMessage: 'Onboarding not started' },
    choseDontQualify: { id: 'choseDontQualify', defaultMessage: 'Worker says s/he does not qualify for IC-only position' },
    onboardingInProcess: { id: 'employeeOnboardingInProcess', defaultMessage: 'Onboarding in process' },
    onboardingDelayed: { id: 'employeeOnboardingDelayed', defaultMessage: 'Onboarding delayed since {inviteAcceptedAt}' },
    onboardingStalled: { id: 'employeeOnboardingStalled', defaultMessage: 'Onboarding stalled since {inviteAcceptedAt}' },
    icDocsApproved: { id: 'icDocsApproved', defaultMessage: 'IC Documents approved' },
    icDocsReviewing: { id: 'icDocsReviewing', defaultMessage: 'Reviewing IC Documents' },
    icDocsNotSubmitted: { id: 'icDocsNotSubmitted', defaultMessage: 'IC documents not submitted' },
    icDocsRejected: { id: 'icDocsRejected', defaultMessage: 'IC Documents rejected' },
    icDocsMissing: { id: 'icDocsMissing', defaultMessage: 'IC Documents missing' },
    icDocsAwaited: { id: 'icDocsAwaited', defaultMessage: 'Awaiting IC documents' },
    icDocs: { id: 'icDocs', defaultMessage: 'IC Documents' },

    // Circle 3
    employeeBGCheckApproved: { id: 'employeeBGCheckApproved', defaultMessage: 'Background check approved' },
    employeeBGCheckUnderReview: { id: 'employeeBGCheckUnderReview', defaultMessage: 'Background check under review' },
    employeeBGCheckException: { id: 'employeeBGCheckException', defaultMessage: 'Background check exception' },
    employeeBGCheckInProcess: { id: 'employeeBGCheckInProcess', defaultMessage: 'Background check in process' },
    employeeBGCheckNotYetStarted: { id: 'employeeBGCheckNotYetStarted', defaultMessage: 'Background check not yet started' },
    employeeBGCheckNotRequired: { id: 'employeeBGCheckNotRequired', defaultMessage: 'Background check not required' },

    // Circle 4
    employeeApprovedWaitingStart: { id: 'employeeApprovedWaitingStart', defaultMessage: 'Awaiting start' },
    employeeApprovedWaitingApproval: { id: 'employeeApprovedWaitingApproval', defaultMessage: 'Awaiting approval' }
});

export default messages;



// WEBPACK FOOTER //
// ./src/text/messages.js